export enum AppointmentStatusEnum {
  SCHEDULED = 1,
  PROCESSING = 2,
  SIGNED = 3,
  COMPLETED = 4,
  CANCELLED = 5,
}
